function Footer () {

    return (

        <div className="navbar-expand-lg navbar-dark">
            <h1 className="footer">
                Copyright © 2022 - 2024 Andreas😎
            </h1>
        </div>
    )
}

export default Footer